<template>
  <div class="outer-wrapper">
    <div class="page-wrapper" v-if="contract_data.project_display_no">
          <contract-page
            :contract_data="contract_data"
            :total_page="total_page"
            :current_page="current_page"
            id="to_print_contract"
          ></contract-page>
    </div>
    <div class="button-wrapper" v-if="!contract_data.sales_account">
      <van-button type="primary" @click="submit">签发</van-button>
    </div>
    <div class="button-wrapper" v-else>
      <p>
        <span>签发人：</span>
        <span>{{ contract_data.sales_name }}</span>
      </p>
    </div>
  </div>
</template>
<script>
import contractPage from "./ContractPage.vue";
let userToken = localStorage.getItem("current_user_token");
const OPTIONS = {
  agentMark: [
    { value: "正常", text: "正常", ratio: 1 , id: "1" },
    { value: "加急", text: "加急", ratio: 1.5 , id: "2" },
    { value: "特急", text: "特急", ratio: 2 , id: "3" }
  ],
  samplePosition: [
    {
      value: "乙方视检测需求或试样状况确定部位。",
      text: "乙方视检测需求或试样状况确定部位。",
      id: "1"
    },
    {
      value: "按甲方指定部位（试样上标注明确）。",
      text: "按甲方指定部位（试样上标注明确）。",
      id: "2"
    }
  ],
  testMethod: [
    {
      value: "甲方授权乙方视检测需求确定检测标准。",
      text: "甲方授权乙方视检测需求确定检测标准。",
      id: "1"
    },
    {
      value: "按甲方指定检测标准（备注栏中注明）。",
      text: "按甲方指定检测标准（备注栏中注明）。",
      id: "2"
    }
  ],
  ifSubpackage: [
    {
      value: "甲方同意乙方视检测需求外发部分或全部检测项目。",
      text: "甲方同意乙方视检测需求外发部分或全部检测项目。",
      id: "1"
    },
    {
      value: "乙方不作检测项目分包处理（检测能力范围内）。",
      text: "乙方不作检测项目分包处理（检测能力范围内）。",
      id: "2"
    }
  ],
  reportStyle: [
    { value: "乙方视需要编制报告。", text: "乙方视需要编制报告。", id: "1" },
    {
      value: "按甲方要求编制报告（备注栏中注明）。",
      text: "按甲方要求编制报告（备注栏中注明）。",
      id: "2"
    },
    {
      value: "CNAS标识章（仅限能力授权检测标准，见公示件）。",
      text: "CNAS标识章（仅限能力授权检测标准，见公示件）。",
      id: "3"
    },
    {
      value: "CMA标识章（仅限能力授权检测标准，见公示件）。",
      text: "CMA标识章（仅限能力授权检测标准，见公示件）。",
      id: "4"
    },
    {
      value: "CNAS和CMA标识章（仅限能力授权检测标准，见公示件）。",
      text: "CNAS和CMA标识章（仅限能力授权检测标准，见公示件）。",
      id: "5"
    }
  ],
  reportDelivery: [
    {
      value: "甲方自取（通知日起保存三个月）。",
      text: "甲方自取（通知日起保存三个月）。",
      price:0,
      id: "1"
    },
    {
      value: "乙方快递（10元费用由甲方另行支付）。",
      text: "乙方快递（10元费用由甲方另行支付）。",
      price:10,
      id: "2"
    },
    {
      value: "乙方快递（20元费用由甲方另行支付）。",
      text: "乙方快递（20元费用由甲方另行支付）。",
      price:20,
      id: "3"
    },
    { 
      value: "乙方快递（免费）。", 
      text: "乙方快递（免费）。", 
      price:0,
      id: "4" 
    }
  ],
  restSample: [
    {
      value: "乙方留存一个月备查，过期由乙方处理。",
      text: "乙方留存一个月备查，过期由乙方处理。",
      id: "1"
    },
    {
      value: "甲方在领取检测报告时取回残余试样。",
      text: "甲方在领取检测报告时取回残余试样。",
      id: "2"
    }
  ],
  reportLanguage: [
    { value: "中文", text: "中文", actvalue:['中文(简体)'],id: "1" },
    { value: "中文+英文", text: "中文+英文", actvalue:['中文(简体)','English'],id: "2" },
    { value: "英文", text: "英文", actvalue:['English'],id: "3" },
  ],
  reportMerge: [
    { value: "一个检测类别一份报告", text: "一个检测类别一份报告", id: "1" },
    { value: "一个检测项目一份报告", text: "一个检测项目一份报告", id: "2" },
    { value: "一个样品一份报告", text: "一个样品一份报告", id: "3" },
    { value: "一份委托单一份报告", text: "一份委托单一份报告", id: "4" }
  ]
};

export default {
  name: "contractView",
  components: {
    contractPage,
  },
  props: {
    project_enid: {
      type: String,
      default: "3"
    }
  },
  data() {
    return {
      options: OPTIONS,
      contract_data: {
        contract_no: NaN,
        project_display_no: "",
        apply_date: "2019.06.01",
        customer: {
          customerCompany: {
            name: "",
            telephone: "",
            fax: "",
            address: ""
          },
          customerPerson: {
            name: "",
            phone: "",
            email: ""
          }
        },
        reportInfo: {
          completeDate: "2019.07.31",
          agentMark: "正常",
          samplePosition: "乙方视检测需求或试样状况确定部位。",
          testMethod: "甲方授权乙方视检测需求确定检测标准。",
          ifSubpackage: "甲方同意乙方视检测需求外发部分或全部检测项目。",
          reportStyle: "乙方视需要编制报告。",
          reportDelivery: "乙方快递（10元费用由甲方另行支付）。",
          restSample: "乙方留存一个月备查，过期由乙方处理。",
          reportLanguage: "中文",
          reportAmount: 1,
          reportMerge: "一个检测类别一份报告",
          remark: ""
        },
        remark: {
          customer: "",
          private: ""
        },
        sample: [],
        totalPrice: "100000"
      },
      printParamsTransfer: {
        id: "to_print_transfer",
        popTitle: "检测任务单"
      },
      ifOld:false,
      printParamsContract: {
        id: "to_print_contract",
        popTitle: "委托检测协议书"
      },
      printParamsContractOld: {
        id: "to_print_contract_old",
        popTitle: "委托检测协议书"
      },
      total_page: 1,
      current_page: 1
    };
  },
  created() {
    this.get_contract_content();
  },
  computed:{
    calculatePrice() {
      let price = 0;
      let tmp_price = 0;
      let reportDeliveryPrice = this.options.reportDelivery.find(val=>val.value===this.contract_data.reportInfo.reportDelivery).price;
      let reportAgentRatio = this.options.agentMark.find(val=>val.value===this.contract_data.reportInfo.agentMark).ratio;
      for (let oneSample of this.contract_data.sample) {
        for (let oneTest of oneSample.testItems) {
          tmp_price = oneTest.choice.price;
          for (let single_choice of oneTest.single_choice) {
            if(single_choice&&Object.keys(single_choice).length!==0){
               tmp_price += single_choice.price;
            }
          }
          for (let multi_choice of oneTest.multi_choice) {
            tmp_price += multi_choice.price;
          }
          price += tmp_price * oneTest.amount;
        }
      }
      return price*reportAgentRatio+reportDeliveryPrice;
    }
  },
  methods: {
    get_contract_content() {
      this.$axios
        .post(this.$url + "/ask_contract_info", {
          userToken: userToken,
          askData: "pre_contract_data",
          project_enid: this.project_enid
        })
        .then(response => {
          if (response.data.do_stat == "ok") {
            this.contract_data = response.data.contract_data;
            this.printParamsTransfer.popTitle =
              "检测任务单(" + this.contract_data.project_display_no + ")";
            this.printParamsContract.popTitle =
              "委托检测协议书(" +
              this.contract_data.project_display_no +
              ")--上海轨道交通检测认证（集团）有限公司";
            this.printParamsContractOld.popTitle = this.printParamsContract.popTitle;
            if(this.contract_data.sample[0].testItems[0].choice){
              this.ifOld = true;
            }
          } else {
            this.$toast.fail("未查到相关委托单信息！");
          }
        });
    },
    submit() {
      this.$axios
        .post(this.$url + "/project_do", {
          userToken: userToken,
          customer: this.contract_data.customer,
          reportInfo: this.contract_data.reportInfo,
          reportInfoOptions:OPTIONS,
          sample: this.contract_data.sample,
          remark:this.contract_data.remark,
          totalPrice: this.contract_data.totalPrice,
          calculatePrice: this.calculatePrice,
          contractNo:this.contract_data.contract_no,
        })
        .then(response => {
          if (response.data.do_stat === "ok") {
            this.get_contract_content()
            this.$toast.success("签发成功！");
          } else {
            this.$toast.fail("您无权进行该操作！");
          }
        })
        .catch(error => {
          this.$toast.fail("请重新登录后操作！"+error);
        });
    },
  }
};
</script>
<style scoped>
.outer-wrapper {
  width:100%;
}
.page-wrapper {
  width: 100%;
}
.button-wrapper{
  text-align: center;
  padding-bottom: 40px;
}
</style>